import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AdminProjectSow from "../components/AdminProjectSow";
import ProjectSOW from "../../../../candidate/project/statementOfWork/components/ProjectSOW/ProjectSOWEdit";
import acceptModal from "../../../../employer/memberProposal/components/acceptModal";
import requestEditModal from "../../../../employer/memberProposal/components/requestEditModal";

import * as projectActions from "../../../../../actions/project.actions";
import * as adminActions from "../../../../../actions/admin.actions";
import * as commonActions from "../../../../../actions/common.actions";
import * as dropdownsActionss from "../../../../../actions/dropdowns.actions";
import * as citiesActions from "../../../../../actions/cities.actions";

const approvedSubHeader = (projectId, totalMatches, totalPitches) => {
  return {
    items: [
      {
        caption: "Project Detail",
        url: `/admin/project/${projectId}/detail`
      },
      {
        caption: `Matches (${totalMatches})`,
        url: `/admin/project/${projectId}/matches`
      },
      {
        caption: `Pitches (${totalPitches})`,
        url: `/admin/project/${projectId}/pitches`
      },
      {
        caption: "SOW",
        url: `/admin/project/${projectId}/sow`
      },
      {
        caption: "Reviews",
        url: `/admin/project/${projectId}/reviews`
      }
    ],
    activeItem: 3
  };
};

const pitchPendingApproval = () => ({
  color: "grey",
  title: "Pending Pitch Approval"
});

const sowPendingApprovalHeaderBar = (acceptSow, requestEdit) => ({
  color: "blue",
  title: "SOW in Draft",
  text: `The Member has submitted the SOW below. If it’s ready, hit “Accept”.
  Otherwise, hit “Request Edits” to message her about changes.`,
  buttons: [
    {
      text: "Request Edits",
      type: "modalTrigger",
      color: "blue",
      modal: requestEditModal,
      modalClick: requestEdit
    },
    {
      text: "Accept",
      type: "modalTrigger",
      modal: acceptModal,
      modalClick: acceptSow
    }
  ]
});

const editsRequestedHeaderBar = () => ({
  color: "grey",
  title: "Edits Requested",
  text: `You have edits requested to be made on this SOW.
   Please incorporate those changes and resubmit the SOW`
});

const sowApprovedHeaderBar = () => ({
  center: false,
  color: "grey",
  title: "Your Project is Underway",
  text: `After you’ve completed the project,
   click the button on the right to kick off the invoicing and review process.`
});

class AdminProjectSowContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentProjectState: null,
      project: null,
      match: null,
      pitch: null,
      sow: null,
      sowAccepted: null
    };

    this.contactEmail = this.contactEmail.bind(this);
    this.submitSOW = this.submitSOW.bind(this);
    this.acceptSow = this.acceptSow.bind(this);
    this.requestEdit = this.requestEdit.bind(this);
  }

  contactEmail(email) {
    const link = `mailto:${email}`;
    const emailWindow = window.open(link, "emailWindow");

    setTimeout(() => {
      if (emailWindow && emailWindow.open && !emailWindow.closed) {
        emailWindow.close();
      }
    }, 10);
  }

  componentDidMount() {
    this.props.adminActions.getProject(this.props.match.params.projectId);
    this.props.projectActions.getStatus();
    this.props.dropdownsActionss.getProjectBudgetRateTypes();
    this.props.dropdownsActionss.getWorkTypes();
    this.props.dropdownsActionss.getTaxStatus();
  }

  componentWillUnmount() {
    this.props.commonActions.setHeaderBar({});
    this.props.commonActions.setSubHeader({});
  }

  componentDidUpdate(prevProps, prevState) {
    this.setHeaderBar(prevState);
    this.setSubHeader(prevProps);
  }

  setHeaderBar(prevState) {
    if (
      !_.isEmpty(this.props.project) &&
      this.props.project !== prevState.project
    ) {
      let currentProjectState = null;
      let headerBar = {};
      let project = null;
      let member = null;
      let pitch = null;
      let sow = null;
      let sowPendingApproval = null;
      let sowAccepted = null;
      let sowEditsRequested = null;

      // search the match that contains an approved pitch
      this.props.project.matches.forEach(match => {
        if (!sow) {
          let currentPitch = _.get(match, "pitch");
          let currentPitchAccepted =
            _.get(currentPitch, "accepted") && currentPitch.accepted;

          let currentPitchMember = null;
          let acceptedPitch = null;
          let acceptedSow = null;

          if (currentPitchAccepted) {
            currentPitchMember = _.get(match, "member");
            acceptedPitch = currentPitch;
            acceptedSow = _.get(currentPitch, "sow");
          }

          if (acceptedPitch) {
            project = this.props.project;
            member = currentPitchMember;
            pitch = acceptedPitch;
          }

          if (acceptedSow) {
            sow = acceptedSow;
            sowAccepted = _.get(acceptedSow, "accepted");
            sowEditsRequested = _.get(acceptedSow, "edits_requested");
            sowPendingApproval = !sowAccepted && !sowEditsRequested;
          }
        }
      });

      if (sow) {
        if (sowAccepted) {
          currentProjectState = "sowApproved";
          headerBar = sowApprovedHeaderBar();
        } else if (sowPendingApproval) {
          currentProjectState = "sowPendingApproval";
          headerBar = sowPendingApprovalHeaderBar(
            this.acceptSow,
            this.requestEdit
          );
        } else if (sowEditsRequested) {
          currentProjectState = "sowEditsRequested";
          headerBar = editsRequestedHeaderBar();
        } else if (!pitch) {
          currentProjectState = "pitchPendingApproval";
          headerBar = pitchPendingApproval();
        }

        this.setState({
          currentProjectState,
          project,
          member,
          pitch,
          sow,
          sowAccepted
        });

        this.props.commonActions.setHeaderBar(headerBar);
      }
    }
  }

  setSubHeader(prevProps) {
    const project = this.props.project;
    const status = _.get(this.props.project, "status.name");

    const totalMatches = _.get(project, "stats.matches.matched");
    const totalPitches =
      _.get(project, "stats.pitches.accepted") +
      _.get(project, "stats.pitches.pending");

    let subHeader = {};
    let currentProjectState = status;

    if (currentProjectState !== undefined && project !== prevProps.project) {
      subHeader = approvedSubHeader(project.id, totalMatches, totalPitches);
      this.props.commonActions.setSubHeader(subHeader);
      this.setState({ currentProjectState });
    }
  }

  acceptSow() {
    const payload = {
      sow_id: this.state.sow.id,
      accepted: true
    };

    this.props.projectActions.acceptSow(
      payload,
      this.state.pitch.id,
      this.state.project.id
    );
  }

  requestEdit(message) {
    const payload = {
      sow_id: this.state.sow.id,
      edits_requested: true,
      message
    };

    this.props.projectActions.acceptSow(
      payload,
      this.state.pitch.id,
      this.state.project.id
    );
  }

  submitSOW(data) {
    const sow = this.state.sow;

    data.city = _.get(data, "city[0].description");

    if (!data.project_flexible) {
      data.project_flexible = false;
    }

    if (sow) {
      this.props.projectActions.updateSOW(sow.id, data, this.state.project.id);
    } else {
      data.pitch_id = this.state.pitch.id;

      this.props.projectActions.storeSOW(data, this.state.project.id);
    }
  }

  renderSowComponent() {
    const {
      projectBudgetRateTypes,
      workTypes,
      taxStatus,
      cities,
      citiesActions
    } = this.props;

    const { pitch, sow, project, member } = this.state;
    const employer = _.get(project, "user");

    let component = null;

    if (!sow) {
      component = (
        <ProjectSOW
          sow={sow}
          projectBudgetRateTypes={
            projectBudgetRateTypes
              ? projectBudgetRateTypes.filter(type => type.id != 78)
              : projectBudgetRateTypes
          }
          workTypes={workTypes}
          taxStatus={taxStatus}
          onSubmit={this.submitSOW}
          disabled={!pitch}
          cities={cities}
          onSearchCities={citiesActions.searchCitiesAutocomplete}
        />
      );
    } else {
      component = (
        <AdminProjectSow
          projectId={project.id}
          sowData={sow}
          sowAceppted={this.state.sowAceppted}
          member={member}
          employer={employer}
          rateType={sow.budget_type}
        />
      );
    }

    return component;
  }

  render() {
    return <div>{this.renderSowComponent()}</div>;
  }
}

const mapStateToProps = state => {
  return {
    project: state.admin.project,
    projectBudgetRateTypes: state.dropdowns.projectBudgetRateTypes.data,
    workTypes: state.dropdowns.workTypes.data,
    taxStatus: state.dropdowns.taxStatus.data,
    cities: state.cities.cities.predictions
  };
};

const mapDispatchToProps = dispatch => {
  return {
    projectActions: bindActionCreators(projectActions, dispatch),
    adminActions: bindActionCreators(adminActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    dropdownsActionss: bindActionCreators(dropdownsActionss, dispatch),
    citiesActions: bindActionCreators(citiesActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminProjectSowContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/project/sow/containers/AdminProjectSowContainer.js